import realtimeComponents from './realtime/index';

export default {
  ...realtimeComponents
}
